import { render, staticRenderFns } from "./SportHeader.vue?vue&type=template&id=731c2362&scoped=true"
import script from "./SportHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportHeader.vue?vue&type=style&index=0&id=731c2362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731c2362",
  null
  
)

export default component.exports